export default __webpack_public_path__ + "96ccf0da64f7c1941f79c0b21db9c3ac.mp3";